/**
 * Craftpedia Intelligence - Comparison Engine Interaction
 * Compliant with AGENTS.md JavaScript guidelines
 */
(function () {
  'use strict';

  var CRAFT_DATABASE = {
    maheshwari: {
      name: 'Maheshwari',
      image: 'https://cdn.shopify.com/s/files/1/0155/8131/files/u6671371355_Studio_lifestyle_product_shot_multiple_sarees_and_ed5f3098-1a1b-474a-9433-86e51ad61097_1.png?v=1',
      features: [
        'Lightweight silk-cotton fabric known for comfort and elegance.',
        'Features signature Zari borders with stripes or checks.',
        'Handwoven by artisans with traditional weaving techniques.',
        'Ideal for festive, office, and everyday ethnic wear.',
        'Soft, breathable, and perfect for all-day comfort.'
      ]
    },
    chanderi: {
      name: 'Chanderi',
      image: 'https://cdn.shopify.com/s/files/1/0155/8131/files/white-original-gond-handpainted-handloom-chanderi-silk-dupatta-02-243.jpg?v=1',
      features: [
        'Lightweight and breathable fabric with sheer gossamer texture.',
        'Soft texture with a natural, subtle sheen.',
        'Handwoven with fine cotton warp and pure silk weft.',
        'Elegant gold zari butis and intricate border motifs.',
        'Comfortable drape for all-day celebratory wear.'
      ]
    },
    banarasi: {
      name: 'Banarasi',
      image: 'https://cdn.shopify.com/s/files/1/0155/8131/files/red-3pc-hand-embroidery-georgette-unstitched-phulkari-dress-material-930.jpg?v=1',
      features: [
        'Opulent, heavy katan silk weave with rich zari brocade.',
        'Intricate floral jal, kalga, and bel motifs inspired by Mughal art.',
        'Master jacquard and pit-loom craftsmanship taking 2-8 weeks.',
        'Prized heirloom textile intended for weddings and grand occasions.',
        'Dense, luxurious drape requiring dry-clean care only.'
      ]
    },
    ajrakh: {
      name: 'Ajrakh',
      image: 'https://cdn.shopify.com/s/files/1/0155/8131/files/Rectangle_2482.jpg?v=1',
      features: [
        '16-stage resist block printing using mineral and vegetable dyes.',
        'Complex geometric star and rosette grid patterns.',
        'Pure breathable cotton and modal with skin-friendly natural colors.',
        'Deep indigo, madder red, and harda earthen tones.',
        'Exceptional colorfastness when washed in cold water.'
      ]
    },
    tussar: {
      name: 'Tussar Silk',
      image: 'https://cdn.shopify.com/s/files/1/0155/8131/files/olive-green-plain-slub-silk-long-straight-kurta-kurtas-722.jpg?v=1',
      features: [
        'Wild forest silk harvested from Antheraea silkworms.',
        'Rich, textured gold honey slubs with earthy tactile handfeel.',
        'Natural thermal regulation—cool in summer, insulating in winter.',
        'Pairs naturally with Kantha embroidery and tribal motifs.',
        'Dry clean recommended to preserve raw luster and body.'
      ]
    }
  };

  CRAFT_DATABASE['tussar-silk'] = CRAFT_DATABASE.tussar;
  CRAFT_DATABASE['tussarsilk'] = CRAFT_DATABASE.tussar;

  function parseFeatures(desc) {
    if (!desc || typeof desc !== 'string') return [];
    if (desc.indexOf('<li') !== -1) {
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = desc;
      var lis = tempDiv.querySelectorAll('li');
      var results = [];
      lis.forEach(function (li) {
        var text = li.textContent.replace(/^[•\-\*\s]+/, '').trim();
        if (text) results.push(text);
      });
      return results;
    }
    return desc
      .split(/\n+/)
      .map(function (s) { return s.replace(/^[•\-\*\s]+/, '').trim(); })
      .filter(Boolean);
  }

  function loadMetaobjects() {
    try {
      var metaScript = document.getElementById('craft-comparison-metaobjects-data');
      if (metaScript && metaScript.textContent) {
        var metaData = JSON.parse(metaScript.textContent);
        if (Array.isArray(metaData) && metaData.length > 0) {
          metaData.forEach(function (item) {
            if (!item || !item.handle) return;
            var features = parseFeatures(item.description);
            var profile = {
              name: item.title || item.handle,
              image: item.image || (CRAFT_DATABASE[item.handle] ? CRAFT_DATABASE[item.handle].image : ''),
              features: features.length > 0 ? features : (CRAFT_DATABASE[item.handle] ? CRAFT_DATABASE[item.handle].features : [])
            };
            CRAFT_DATABASE[item.handle] = profile;
            CRAFT_DATABASE[item.handle.toLowerCase()] = profile;
            CRAFT_DATABASE[item.handle.replace(/[^a-z0-9]/gi, '')] = profile;
          });
        }
      }
    } catch (err) {
      console.warn('Craft comparison metaobjects parse notice:', err);
    }
  }

  function getCraftData(craftKey) {
    if (!craftKey) return null;
    var rawKey = String(craftKey);
    var cleanKey = rawKey.toLowerCase().replace(/[^a-z0-9]/g, '');
    var data = CRAFT_DATABASE[rawKey] || CRAFT_DATABASE[rawKey.toLowerCase()] || CRAFT_DATABASE[cleanKey];
    if (!data) {
      for (var k in CRAFT_DATABASE) {
        var candidateClean = k.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (candidateClean && (candidateClean.indexOf(cleanKey) === 0 || cleanKey.indexOf(candidateClean) === 0)) {
          data = CRAFT_DATABASE[k];
          break;
        }
      }
    }
    return data;
  }

  function getOptionTextFromSelect(selectEls, targetVal) {
    if (!targetVal) return '';
    for (var i = 0; i < selectEls.length; i++) {
      var sel = selectEls[i];
      if (sel && sel.options) {
        for (var j = 0; j < sel.options.length; j++) {
          if (sel.options[j].value === targetVal) {
            return sel.options[j].text.trim();
          }
        }
      }
    }
    var data = getCraftData(targetVal);
    if (data && data.name) return data.name;
    return targetVal;
  }

  function initComparisonEngine() {
    loadMetaobjects();

    var section = document.querySelector('[data-compare-section]');
    if (!section) return;

    var selectOneEls = section.querySelectorAll('[data-compare-select="1"]');
    var selectTwoEls = section.querySelectorAll('[data-compare-select="2"]');

    var textOneEls = section.querySelectorAll('[data-compare-text="1"]');
    var textTwoEls = section.querySelectorAll('[data-compare-text="2"]');

    var imgOne = section.querySelector('[data-compare-img="1"]');
    var imgTwo = section.querySelector('[data-compare-img="2"]');

    var listOne = section.querySelector('[data-compare-list="1"]');
    var listTwo = section.querySelector('[data-compare-list="2"]');

    var noteTitle = section.querySelector('[data-compare-note-title]');
    var noteDesc = section.querySelector('[data-compare-note-desc]');
    var defaultNoteDesc = noteDesc ? noteDesc.getAttribute('data-compare-note-desc') || '' : '';

    function updateColumn(craftKey, imgEl, listEl) {
      if (!craftKey) return;
      var data = getCraftData(craftKey);
      var craftName = (data && data.name) ? data.name : getOptionTextFromSelect(selectOneEls, craftKey);

      if (imgEl) {
        var targetImage = (data && data.image) ? data.image : 'https://cdn.shopify.com/s/files/1/0155/8131/files/Rectangle_2482.jpg?v=1';
        imgEl.style.opacity = '0.4';
        setTimeout(function () {
          imgEl.src = targetImage;
          imgEl.alt = craftName;
          imgEl.style.opacity = '1';
        }, 150);
      }

      if (listEl) {
        listEl.innerHTML = '';
        var features = (data && Array.isArray(data.features)) ? data.features : [];
        if (features.length > 0) {
          features.forEach(function (feat) {
            var li = document.createElement('li');
            li.className = 'cp-compare-item';
            li.innerHTML = '<span class="cp-compare-check">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">' +
              '<circle cx="9" cy="9" r="8.25" stroke="#4B6246" stroke-width="1.5"/>' +
              '<path d="M5.5 9L8 11.5L12.5 7" stroke="#4B6246" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg></span>' +
              '<span>' + feat + '</span>';
            listEl.appendChild(li);
          });
        } else {
          var emptyLi = document.createElement('li');
          emptyLi.className = 'cp-compare-item';
          emptyLi.innerHTML = '<span class="cp-compare-check">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">' +
            '<circle cx="9" cy="9" r="8.25" stroke="#888" stroke-width="1.5"/>' +
            '</svg></span>' +
            '<span>No detailed bullet points available for ' + craftName + ' yet.</span>';
          listEl.appendChild(emptyLi);
        }
      }
    }

    function updateNote(val1, val2) {
      var d1 = getCraftData(val1);
      var d2 = getCraftData(val2);

      var n1 = d1 ? d1.name : getOptionTextFromSelect(selectOneEls, val1);
      var n2 = d2 ? d2.name : getOptionTextFromSelect(selectTwoEls, val2);

      if (noteTitle) {
        if (val1 && val2 && val1 === val2) {
          noteTitle.textContent = 'Comparing ' + n1 + ' with itself.';
        } else {
          noteTitle.textContent = 'Comparison data for ' + n1 + ' vs ' + n2 + ' is being researched.';
        }
      }
      if (noteDesc) {
        if (val1 && val2 && val1 === val2) {
          noteDesc.textContent = 'Select two different crafts to examine side-by-side technical differences.';
        } else {
          noteDesc.textContent = defaultNoteDesc;
        }
      }
    }

    function syncState(val1, val2) {
      if (val1) {
        selectOneEls.forEach(function (sel) {
          sel.value = val1;
        });
        var label1 = getOptionTextFromSelect(selectOneEls, val1);
        textOneEls.forEach(function (el) {
          el.textContent = label1;
        });
      }

      if (val2) {
        selectTwoEls.forEach(function (sel) {
          sel.value = val2;
        });
        var label2 = getOptionTextFromSelect(selectTwoEls, val2);
        textTwoEls.forEach(function (el) {
          el.textContent = label2;
        });
      }
    }

    function getInitialValue(selectEls, fallbackVal) {
      for (var i = 0; i < selectEls.length; i++) {
        var optSelected = selectEls[i].querySelector('option[selected]');
        if (optSelected && optSelected.value) {
          return optSelected.value;
        }
        if (selectEls[i].value) {
          return selectEls[i].value;
        }
      }
      return fallbackVal || '';
    }

    var currentCraft1 = getInitialValue(selectOneEls, 'maheshwari');
    var currentCraft2 = getInitialValue(selectTwoEls, 'chanderi');

    if (selectOneEls.length > 0) {
      selectOneEls.forEach(function (sel) {
        sel.addEventListener('change', function (e) {
          currentCraft1 = e.target.value;
          syncState(currentCraft1, currentCraft2);
          updateColumn(currentCraft1, imgOne, listOne);
          updateNote(currentCraft1, currentCraft2);
        });
      });
    }

    if (selectTwoEls.length > 0) {
      selectTwoEls.forEach(function (sel) {
        sel.addEventListener('change', function (e) {
          currentCraft2 = e.target.value;
          syncState(currentCraft1, currentCraft2);
          updateColumn(currentCraft2, imgTwo, listTwo);
          updateNote(currentCraft1, currentCraft2);
        });
      });
    }

    // Set initial synchronization
    if (selectOneEls.length > 0 && selectTwoEls.length > 0) {
      syncState(currentCraft1, currentCraft2);
      updateColumn(currentCraft1, imgOne, listOne);
      updateColumn(currentCraft2, imgTwo, listTwo);
      updateNote(currentCraft1, currentCraft2);
    }

    initAnchorSmoothScroll();
  }

  function initAnchorSmoothScroll() {
    try {
      if (!document || !document.querySelectorAll) return;
      var jumpLinks = document.querySelectorAll('a[href^="#cp-"]');
      if (!jumpLinks || jumpLinks.length === 0) return;
      jumpLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          try {
            var href = link.getAttribute('href');
            if (!href || href.length < 2) return;
            var targetEl = document.querySelector(href);
            if (targetEl) {
              e.preventDefault();
              var header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
              var headerHeight = (header && typeof header.offsetHeight === 'number') ? header.offsetHeight : 110;
              var rect = targetEl.getBoundingClientRect();
              var scrollY = window.pageYOffset || (document.documentElement ? document.documentElement.scrollTop : 0) || 0;
              var targetTop = rect.top + scrollY - headerHeight - 20;
              if (window.scrollTo) {
                window.scrollTo({
                  top: Math.max(0, targetTop),
                  behavior: 'smooth'
                });
              }
              if (window.history && window.history.pushState) {
                window.history.pushState(null, '', href);
              }
            }
          } catch (err) {
            console.warn('Anchor smooth scroll click notice:', err);
          }
        });
      });
    } catch (err) {
      console.warn('Anchor smooth scroll init notice:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComparisonEngine);
  } else {
    initComparisonEngine();
  }
})();
